(() => {
  const SURCHARGE_VARIANT_ID = 52098934997288;
  const RURAL_POSTCODES = new Set([
    '0170', '0171', '0172', '0173', '0174', '0175', '0176', '0178', '0179', '0181', '0182', '0184', '0185', '0192',
    '0193', '0272', '0281', '0282', '0283', '0293', '0294', '0295', '0370', '0371', '0372', '0373', '0374', '0376',
    '0377', '0379', '0381', '0391', '0448', '0472', '0473', '0474', '0475', '0476', '0478', '0479', '0481', '0482',
    '0483', '0484', '0486', '0491', '0492', '0494', '0496', '0571', '0573', '0582', '0583', '0587', '0588', '0589',
    '0591', '0592', '0593', '0594', '0772', '0781', '0782', '0792', '0793', '0794', '0871', '0873', '0874', '0875',
    '0881', '0882', '0883', '0891', '0892', '0972', '0973', '0974', '0975', '0977', '0981', '0982', '0983', '0984',
    '0985', '0986', '0991', '0992', '0993', '0994', '1971', '2471', '2472', '2473', '2474', '2571', '2576', '2577',
    '2578', '2579', '2580', '2582', '2583', '2584', '2585', '2675', '2676', '2677', '2678', '2679', '2681', '2682',
    '2683', '2684', '2693', '2694', '2695', '2696', '2697', '3072', '3073', '3074', '3076', '3077', '3078', '3079',
    '3081', '3083', '3096', '3097', '3170', '3171', '3172', '3173', '3174', '3175', '3176', '3177', '3178', '3179',
    '3180', '3181', '3182', '3183', '3186', '3187', '3188', '3189', '3191', '3192', '3193', '3194', '3196', '3197',
    '3198', '3199', '3281', '3282', '3283', '3284', '3285', '3286', '3287', '3288', '3289', '3290', '3293', '3295',
    '3296', '3297', '3371', '3372', '3373', '3374', '3375', '3377', '3378', '3379', '3380', '3381', '3382', '3384',
    '3385', '3391', '3392', '3393', '3471', '3472', '3473', '3474', '3475', '3481', '3482', '3483', '3484', '3485',
    '3491', '3492', '3493', '3494', '3495', '3496', '3574', '3575', '3576', '3577', '3578', '3579', '3581', '3582',
    '3583', '3584', '3591', '3592', '3597', '3671', '3672', '3673', '3674', '3681', '3682', '3691', '3771', '3772',
    '3781', '3782', '3784', '3791', '3792', '3793', '3794', '3872', '3873', '3874', '3875', '3876', '3877', '3878',
    '3879', '3880', '3881', '3882', '3883', '3885', '3886', '3889', '3894', '3895', '3970', '3971', '3972', '3973',
    '3974', '3975', '3976', '3977', '3978', '3979', '3980', '3981', '3982', '3983', '3985', '3986', '3987', '3988',
    '3989', '3990', '3991', '3992', '3993', '3994', '3995', '3996', '3997', '3998', '4071', '4072', '4073', '4075',
    '4077', '4078', '4079', '4081', '4082', '4083', '4086', '4087', '4091', '4092', '4093', '4094', '4171', '4172',
    '4174', '4175', '4178', '4179', '4180', '4181', '4182', '4183', '4184', '4186', '4188', '4189', '4191', '4193',
    '4195', '4196', '4197', '4198', '4271', '4272', '4273', '4274', '4275', '4276', '4277', '4278', '4279', '4281',
    '4282', '4283', '4284', '4285', '4286', '4287', '4288', '4291', '4292', '4293', '4294', '4295', '4371', '4372',
    '4373', '4374', '4375', '4376', '4377', '4378', '4379', '4381', '4382', '4383', '4386', '4387', '4388', '4389',
    '4390', '4391', '4392', '4393', '4394', '4395', '4396', '4397', '4398', '4399', '4470', '4471', '4472', '4473',
    '4474', '4475', '4476', '4477', '4478', '4479', '4481', '4571', '4572', '4573', '4574', '4575', '4576', '4577',
    '4578', '4581', '4582', '4584', '4585', '4586', '4587', '4588', '4591', '4592', '4597', '4598', '4671', '4672',
    '4673', '4674', '4675', '4678', '4679', '4681', '4682', '4684', '4685', '4691', '4694', '4696', '4771', '4774',
    '4775', '4777', '4779', '4780', '4781', '4782', '4783', '4784', '4785', '4786', '4787', '4788', '4789', '4791',
    '4792', '4793', '4794', '4795', '4796', '4797', '4884', '4891', '4893', '4894', '4970', '4971', '4972', '4973',
    '4974', '4975', '4976', '4977', '4978', '4979', '4981', '4982', '4983', '4984', '4985', '4986', '4987', '4988',
    '4989', '4990', '4991', '4992', '4993', '4994', '4995', '4996', '4997', '4998', '4999', '5371', '5372', '5373',
    '5381', '5391', '5570', '5571', '5572', '5573', '5574', '5575', '5581', '5582', '5583', '5771', '5772', '5773',
    '5781', '5782', '5783', '5784', '5791', '5792', '5794', '5871', '5872', '5881', '5882', '5883', '5884', '5885',
    '5886', '5887', '5888', '5889', '5890', '5894', '6972', '7071', '7072', '7073', '7077', '7081', '7091', '7095',
    '7096', '7173', '7175', '7178', '7182', '7183', '7192', '7193', '7194', '7195', '7196', '7197', '7198', '7271',
    '7272', '7273', '7274', '7275', '7276', '7281', '7282', '7284', '7285', '7371', '7373', '7374', '7379', '7381',
    '7382', '7383', '7384', '7385', '7387', '7391', '7392', '7395', '7471', '7472', '7473', '7475', '7476', '7477',
    '7481', '7482', '7483', '7491', '7495', '7571', '7572', '7580', '7581', '7582', '7583', '7591', '7670', '7671',
    '7672', '7673', '7674', '7675', '7676', '7677', '7678', '7681', '7682', '7683', '7691', '7692', '7771', '7772',
    '7773', '7774', '7775', '7776', '7777', '7778', '7781', '7782', '7783', '7784', '7791', '7871', '7872', '7873',
    '7875', '7881', '7882', '7883', '7884', '7885', '7886', '7891', '7892', '7893', '7895', '7971', '7972', '7973',
    '7974', '7975', '7977', '7978', '7979', '7980', '7982', '7983', '7984', '7985', '7986', '7987', '7988', '7990',
    '7991', '7992', '8971', '9073', '9074', '9076', '9077', '9081', '9082', '9085', '9091', '9092', '9271', '9272',
    '9273', '9274', '9281', '9282', '9291', '9292', '9371', '9372', '9376', '9377', '9382', '9383', '9384', '9386',
    '9387', '9391', '9392', '9393', '9395', '9396', '9397', '9398', '9471', '9472', '9481', '9482', '9483', '9491',
    '9492', '9493', '9494', '9495', '9498', '9571', '9572', '9583', '9584', '9585', '9586', '9587', '9591', '9593',
    '9596', '9597', '9598', '9672', '9679', '9682', '9683', '9689', '9691', '9771', '9772', '9773', '9774', '9775',
    '9776', '9777', '9778', '9779', '9781', '9782', '9783', '9791', '9792', '9793', '9794', '9871', '9872', '9874',
    '9875', '9876', '9877', '9879', '9881', '9883', '9884', '9891', '9892', '9893'
  ]);

  if (window.SRVP_RURAL_SURCHARGE) {
    window.SRVP_RURAL_SURCHARGE.refresh();
    return;
  }

  const state = {
    verified: false,
    busy: false,
    restoreStarted: false,
    method: '',
    postcode: '',
    classification: null,
    activeWidget: null,
  };

  const CHECKOUT_RETURN_KEY = 'srvp-rural-checkout-started';
  const DELIVERY_ATTRIBUTE_NAMES = [
    'Delivery Method Intent',
    'Postcode Logged',
    'Delivery Postcode',
    'Delivery Postcode Source',
    'Delivery Classification',
    'Rural Surcharge Included',
    'Rural Delivery Declared',
    'Delivery Classification Source',
    'Delivery Review Instruction',
  ];

  let emptyCartResetBusy = false;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const cartUrl = (path) => root + path;
  const widgets = () => Array.from(document.querySelectorAll('[data-rural-surcharge-gatekeeper]'));
  const hasWidget = () => widgets().length > 0;
  const visibleWidget = () =>
    widgets().find((widget) => widget.offsetParent !== null) || widgets()[0] || null;

  const cleanPostcode = (value) =>
    String(value || '')
      .trim()
      .replace(/\D/g, '')
      .slice(0, 4);

  const surchargeItems = (cart) =>
    (cart.items || []).filter(
      (item) => Number(item.variant_id || item.id) === SURCHARGE_VARIANT_ID
    );

  const merchandiseItems = (cart) =>
    (cart.items || []).filter(
      (item) => Number(item.variant_id || item.id) !== SURCHARGE_VARIANT_ID
    );

  const lastMerchandiseItem = (cart) => {
    const items = merchandiseItems(cart);
    return items[items.length - 1];
  };

  const parentKeyFor = (item) =>
    item && item.parent_relationship
      ? item.parent_relationship.parent_key ||
        (item.parent_relationship.parent && item.parent_relationship.parent.key) ||
        ''
      : '';

  const requestCart = async (path, options = {}) => {
    const response = await fetch(cartUrl(path), options);
    let payload = {};

    try {
      payload = await response.json();
    } catch (error) {
      payload = {};
    }

    if (!response.ok) {
      throw new Error(
        payload.description || payload.message || `Shopify cart request failed (${response.status}).`
      );
    }

    return payload;
  };

  const refreshCartDrawer = async () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      throw new Error('The cart drawer is unavailable.');
    }

    const sections = await requestCart('?sections=cart-drawer,cart-icon-bubble', {
      headers: { Accept: 'application/json' },
    });

    if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) {
      throw new Error('The cart drawer could not be refreshed.');
    }

    state.restoreStarted = false;
    closeDialogs(true);
    drawer.renderContents({ sections });
    window.requestAnimationFrame(refresh);
  };

  const setFeedback = (message, status = '') => {
    widgets().forEach((widget) => {
      const feedback = widget.querySelector('[data-rural-feedback]');
      if (!feedback) return;

      feedback.textContent = message;
      feedback.className = 'rural-surcharge-gatekeeper__feedback';
      if (!message) return;

      feedback.classList.add('is-visible');
      if (status) feedback.classList.add(`is-${status}`);
    });
  };

  const setInputs = (postcode) => {
    widgets().forEach((widget) => {
      const input = widget.querySelector('[data-rural-postcode]');
      if (input) input.value = postcode;

      const copy = widget.querySelector('[data-rural-postcode-copy]');
      if (copy) {
        copy.textContent = postcode.length === 4
          ? 'Confirm this postcode or enter a different postcode.'
          : 'Enter your postcode to check for a rural surcharge.';
      }
    });
  };

  const setControlsBusy = (busy) => {
    widgets().forEach((widget) => {
      widget
        .querySelectorAll('[data-rural-recheck], [data-rural-method]')
        .forEach((button) => {
          button.disabled = busy;
        });
    });
  };

  const setContinueEnabled = (enabled) => {
    widgets().forEach((widget) => {
      const button = widget.querySelector('[data-rural-dialog-continue]');
      if (button) button.disabled = !enabled;
    });
  };

  const setDialogMethod = (method) => {
    widgets().forEach((widget) => {
      widget.querySelectorAll('[data-rural-method]').forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.ruralMethod === method ? 'true' : 'false');
      });

      const deliveryFields = widget.querySelector('[data-rural-delivery-fields]');
      const pickupFields = widget.querySelector('[data-rural-pickup-fields]');
      if (deliveryFields) deliveryFields.hidden = method !== 'delivery';
      if (pickupFields) pickupFields.hidden = method !== 'pickup';
    });
  };

  const setCompact = () => {
    widgets().forEach((widget) => {
      const compact = widget.querySelector('[data-rural-compact]');
      const title = widget.querySelector('[data-rural-compact-title]');
      const status = widget.querySelector('[data-rural-compact-status]');
      const continueShopping = widget.querySelector('[data-rural-continue-shopping]');
      if (continueShopping) {
        continueShopping.hidden = !state.verified || !state.method;
      }
      if (!compact || !title || !status) return;

      compact.hidden = !state.verified || !state.method;
      if (state.method === 'pickup') {
        title.textContent = 'Pickup intended';
        status.textContent = 'Confirm Pick up at checkout.';
        return;
      }

      title.textContent = `Delivery postcode: ${state.postcode}`;
      status.textContent = state.classification && state.classification.rural
        ? 'Rural delivery surcharge added.'
        : 'No rural surcharge applies.';
    });
  };

  const closeDialogs = (force = false) => {
    if (!force && !state.verified) return;

    widgets().forEach((widget) => {
      const dialog = widget.querySelector('[data-rural-dialog]');
      if (dialog) dialog.hidden = true;
    });
    state.activeWidget = null;
    document.documentElement.classList.remove('srvp-rural-dialog-open');
  };

  const openDialog = (widget = null) => {
    const target = widget || visibleWidget();
    if (!target) return;

    widgets().forEach((item) => {
      const dialog = item.querySelector('[data-rural-dialog]');
      if (dialog) dialog.hidden = item !== target;

      const cancel = item.querySelector('[data-rural-close-dialog].rural-delivery-dialog__cancel');
      if (cancel) cancel.hidden = !state.verified;
    });

    state.activeWidget = target;
    document.documentElement.classList.add('srvp-rural-dialog-open');
    setDialogMethod(state.method);
    setInputs(state.postcode);
    setContinueEnabled(state.verified);

    if (state.method === 'delivery') {
      window.requestAnimationFrame(() => {
        const input = target.querySelector('[data-rural-postcode]');
        if (input) input.focus();
      });
    }
  };

  const checkoutRecheckRequired = () => {
    try {
      return window.sessionStorage.getItem(CHECKOUT_RETURN_KEY) === 'true';
    } catch (error) {
      return false;
    }
  };

  const setCheckoutStarted = (started) => {
    try {
      if (started) {
        window.sessionStorage.setItem(CHECKOUT_RETURN_KEY, 'true');
      } else {
        window.sessionStorage.removeItem(CHECKOUT_RETURN_KEY);
      }
    } catch (error) {
      // Storage can be unavailable in restricted browser modes.
    }
  };

  const syncCheckoutState = () => {
    if (!hasWidget()) {
      document.documentElement.classList.remove(
        'srvp-rural-check-required',
        'srvp-rural-verified',
        'srvp-rural-dialog-open'
      );
      return;
    }

    document.documentElement.classList.add('srvp-rural-check-required');
    document.documentElement.classList.toggle('srvp-rural-verified', state.verified);

    document
      .querySelectorAll('button[name="checkout"], input[name="checkout"]')
      .forEach((button) => {
        button.disabled = !state.verified;
        button.setAttribute('aria-disabled', state.verified ? 'false' : 'true');
      });
  };

  const setVerified = (verified) => {
    state.verified = Boolean(verified);
    setCompact();
    syncCheckoutState();
  };

  const clearDeliveryDecisionIfCartEmpty = async (existingCart = null) => {
    if (emptyCartResetBusy) return false;

    emptyCartResetBusy = true;

    try {
      const cart = existingCart || await requestCart('cart.js', {
        headers: { Accept: 'application/json' },
      });

      if (merchandiseItems(cart).length > 0) return false;

      const attributes = cart.attributes || {};
      const hasSavedDecision = DELIVERY_ATTRIBUTE_NAMES.some(
        (name) => String(attributes[name] || '').length > 0
      );

      state.method = '';
      state.postcode = '';
      state.classification = null;
      setCheckoutStarted(false);
      setInputs('');
      setFeedback('');
      setVerified(false);
      closeDialogs(true);

      if (!hasSavedDecision) return true;

      const clearedAttributes = {};
      DELIVERY_ATTRIBUTE_NAMES.forEach((name) => {
        clearedAttributes[name] = '';
      });

      await requestCart('cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          attributes: clearedAttributes,
        }),
      });

      if (hasWidget()) {
        state.restoreStarted = false;
        window.requestAnimationFrame(refresh);
      }

      return true;
    } catch (error) {
      console.error('Empty cart delivery reset failed:', error);
      return false;
    } finally {
      emptyCartResetBusy = false;
    }
  };

  const classificationFor = (postcode) => {
    const rural = RURAL_POSTCODES.has(postcode);
    return {
      rural,
      source: 'Postcode list',
    };
  };

  const reconcileCart = async (postcode, postcodeSource = 'Customer entered') => {
    const classification = classificationFor(postcode);
    const cart = await requestCart('cart.js', {
      headers: { Accept: 'application/json' },
    });
    const items = surchargeItems(cart);
    const parentItem = lastMerchandiseItem(cart);
    const parentLineKey = parentItem ? parentItem.key : '';
    const nestedItem = items.find((item) => parentKeyFor(item) === parentLineKey);
    const shouldAddNestedItem =
      classification.rural && Boolean(parentLineKey) && !nestedItem;

    const updates = {};
    if (classification.rural && parentLineKey) {
      items.forEach((item) => {
        updates[item.key] = item === nestedItem ? 1 : 0;
      });
    } else {
      items.forEach((item) => {
        updates[item.key] = 0;
      });
    }

    const body = {
      attributes: {
        'Delivery Method Intent': 'Courier delivery',
        'Postcode Logged': postcode,
        'Delivery Postcode': postcode,
        'Delivery Postcode Source': postcodeSource,
        'Delivery Classification': classification.rural ? 'Rural' : 'Standard',
        'Rural Surcharge Included': classification.rural ? 'Yes' : 'No',
        'Rural Delivery Declared': 'No',
        'Delivery Classification Source': classification.source,
        'Delivery Review Instruction': 'Compare Delivery Postcode with final shipping postcode',
      },
    };

    if (Object.keys(updates).length > 0) body.updates = updates;

    await requestCart('cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (shouldAddNestedItem) {
      await requestCart('cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: SURCHARGE_VARIANT_ID,
              quantity: 1,
              parent_line_key: parentLineKey,
              properties: {
                _automatic_rural_surcharge: 'true',
              },
            },
          ],
        }),
      });
    }

    return classification;
  };

  const reconcilePickup = async () => {
    const cart = await requestCart('cart.js', {
      headers: { Accept: 'application/json' },
    });
    const updates = {};

    surchargeItems(cart).forEach((item) => {
      updates[item.key] = 0;
    });

    const body = {
      attributes: {
        'Delivery Method Intent': 'Pickup',
        'Postcode Logged': '',
        'Delivery Postcode': '',
        'Delivery Postcode Source': '',
        'Delivery Classification': 'Pickup',
        'Rural Surcharge Included': 'No',
        'Rural Delivery Declared': 'No',
        'Delivery Classification Source': 'Customer selection',
        'Delivery Review Instruction': 'Confirm local pickup at checkout',
      },
    };

    if (Object.keys(updates).length > 0) body.updates = updates;

    await requestCart('cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });
  };

  const verifyWidget = async (widget) => {
    if (state.busy) return;

    const input = widget.querySelector('[data-rural-postcode]');
    const postcode = cleanPostcode(input && input.value);

    setInputs(postcode);

    if (postcode.length !== 4) {
      setVerified(false);
      setFeedback('Please enter a valid four-digit New Zealand postcode.', 'error');
      return;
    }

    state.busy = true;
    setControlsBusy(true);
    setContinueEnabled(false);
    setVerified(false);

    const expected = classificationFor(postcode);
    setFeedback(
      expected.rural
        ? 'Rural delivery identified. Adding the rural surcharge…'
        : 'Standard delivery identified. Updating the cart…',
      expected.rural ? 'rural' : 'standard'
    );

    try {
      const classification = await reconcileCart(postcode);
      state.method = 'delivery';
      state.postcode = postcode;
      state.classification = classification;
      setCheckoutStarted(false);
      setFeedback(
        classification.rural
          ? `Rural surcharge added for postcode ${postcode}. Final shipping calculated at checkout.`
          : `No rural surcharge applies for postcode ${postcode}. Final shipping calculated at checkout.`,
        classification.rural ? 'rural' : 'standard'
      );
      state.busy = false;
      setControlsBusy(false);
      setContinueEnabled(true);
      setVerified(true);
    } catch (error) {
      console.error('Rural surcharge update failed:', error);
      setFeedback(`${error.message} Please try again.`, 'error');
      setVerified(false);
      state.busy = false;
      setControlsBusy(false);
    }
  };

  const selectPickup = async (widget) => {
    if (state.busy) return;

    state.busy = true;
    state.method = 'pickup';
    state.postcode = '';
    state.classification = null;
    setInputs('');
    setDialogMethod('pickup');
    setControlsBusy(true);
    setContinueEnabled(false);
    setVerified(false);
    setFeedback('Updating the cart for pickup…', 'standard');

    try {
      await reconcilePickup();
      setCheckoutStarted(false);
      state.busy = false;
      setControlsBusy(false);
      setFeedback(
        'Pickup selected. Choose Pick up again at checkout to confirm your collection location.',
        'standard'
      );
      setContinueEnabled(true);
      setVerified(true);
      if (widget) state.activeWidget = widget;
    } catch (error) {
      console.error('Pickup selection failed:', error);
      setFeedback(`${error.message} Please try again.`, 'error');
      state.busy = false;
      setControlsBusy(false);
      setVerified(false);
    }
  };

  const restore = async () => {
    if (state.restoreStarted || !hasWidget()) return;
    state.restoreStarted = true;
    setVerified(false);

    try {
      const cart = await requestCart('cart.js', {
        headers: { Accept: 'application/json' },
      });

      if (await clearDeliveryDecisionIfCartEmpty(cart)) return;

      const attributes = cart.attributes || {};
      const storedPostcode = cleanPostcode(
        attributes['Delivery Postcode'] || attributes['Postcode Logged']
      );
      const storedMethod = attributes['Delivery Method Intent'] === 'Pickup'
        ? 'pickup'
        : storedPostcode.length === 4
          ? 'delivery'
          : '';
      const customerPostcode = cleanPostcode(
        widgets().map((widget) => widget.dataset.customerPostcode).find(Boolean)
      );
      const storedPostcodeSource = attributes['Delivery Postcode Source'] || '';
      const customerEnteredPostcode = storedPostcodeSource === 'Customer entered';
      const postcode = customerEnteredPostcode
        ? storedPostcode
        : customerPostcode.length === 4
          ? customerPostcode
          : storedPostcode;

      state.method = storedMethod;
      state.postcode = postcode;
      setInputs(postcode);

      if (storedMethod === 'pickup') {
        const pickupMatches =
          surchargeItems(cart).length === 0 &&
          attributes['Delivery Classification'] === 'Pickup';

        if (!pickupMatches) {
          await reconcilePickup();
          window.location.reload();
          return;
        }

        state.classification = null;
        setFeedback(
          'Pickup selected. Choose Pick up again at checkout to confirm your collection location.',
          'standard'
        );
        setVerified(true);
        closeDialogs(true);
        return;
      }

      if (checkoutRecheckRequired()) {
        if (postcode.length === 4) state.method = 'delivery';
        setFeedback('Confirm that this postcode matches your checkout delivery address.', 'error');
        setContinueEnabled(false);
        openDialog();
        return;
      }

      if (!storedMethod) {
        state.method = postcode.length === 4 ? 'delivery' : '';
        state.classification = null;
        setVerified(false);
        setFeedback('');
        openDialog();
        return;
      }

      if (
        storedMethod === 'delivery' &&
        !customerEnteredPostcode &&
        customerPostcode.length === 4 &&
        customerPostcode !== storedPostcode
      ) {
        await reconcileCart(customerPostcode, 'Customer default address');
        window.location.reload();
        return;
      }

      if (postcode.length !== 4) {
        setFeedback('');
        state.method = '';
        state.classification = null;
        setVerified(false);
        openDialog();
        return;
      }

      const expected = classificationFor(postcode);
      state.method = 'delivery';
      state.postcode = postcode;
      state.classification = expected;
      const items = surchargeItems(cart);
      const parentItem = lastMerchandiseItem(cart);
      const parentLineKey = parentItem ? parentItem.key : '';
      const cartMatches = expected.rural
        ? items.length === 1 &&
          items[0].quantity === 1 &&
          Boolean(parentLineKey) &&
          parentKeyFor(items[0]) === parentLineKey
        : items.length === 0;
      const attributesMatch =
        attributes['Delivery Classification'] === (expected.rural ? 'Rural' : 'Standard');

      if (!cartMatches || !attributesMatch) {
        await reconcileCart(postcode);
        window.location.reload();
        return;
      }

      setInputs(postcode);
      setFeedback(
        expected.rural
          ? `Rural surcharge added for postcode ${postcode}. Final shipping calculated at checkout.`
          : `No rural surcharge applies for postcode ${postcode}. Final shipping calculated at checkout.`,
        expected.rural ? 'rural' : 'standard'
      );
      setVerified(true);
      closeDialogs(true);
    } catch (error) {
      console.error('Saved postcode verification failed:', error);
      setFeedback(`${error.message} Please verify your postcode again.`, 'error');
      setVerified(false);
    }
  };

  const refresh = () => {
    syncCheckoutState();
    if (!hasWidget()) {
      clearDeliveryDecisionIfCartEmpty();
      return;
    }

    if (!state.restoreStarted) restore();
  };

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-rural-open-dialog]');
    if (open) {
      event.preventDefault();
      openDialog(open.closest('[data-rural-surcharge-gatekeeper]'));
      return;
    }

    const close = event.target.closest('[data-rural-close-dialog]');
    if (close) {
      event.preventDefault();
      closeDialogs();
      return;
    }

    const method = event.target.closest('[data-rural-method]');
    if (method) {
      event.preventDefault();
      const widget = method.closest('[data-rural-surcharge-gatekeeper]');
      const selectedMethod = method.dataset.ruralMethod;

      if (selectedMethod === 'pickup') {
        selectPickup(widget);
        return;
      }

      state.method = 'delivery';
      state.classification = null;
      setDialogMethod('delivery');
      setVerified(false);
      setContinueEnabled(false);
      setFeedback('');
      const input = widget && widget.querySelector('[data-rural-postcode]');
      if (input) input.focus();
      return;
    }

    const recheck = event.target.closest('[data-rural-recheck]');
    if (recheck) {
      event.preventDefault();
      const widget = recheck.closest('[data-rural-surcharge-gatekeeper]');
      if (widget) verifyWidget(widget);
      return;
    }

    const continueButton = event.target.closest('[data-rural-dialog-continue]');
    if (continueButton) {
      event.preventDefault();
      if (!state.verified) return;
      continueButton.disabled = true;
      try {
        await refreshCartDrawer();
      } catch (error) {
        console.error('Cart drawer refresh failed:', error);
        window.location.assign(cartUrl('cart'));
      }
      return;
    }

    const continueShopping = event.target.closest('[data-rural-continue-shopping]');
    if (continueShopping) {
      event.preventDefault();
      try {
        const cart = await requestCart('cart.js', {
          headers: { Accept: 'application/json' },
        });
        const product = lastMerchandiseItem(cart);
        if (product && product.url) {
          window.location.assign(product.url);
          return;
        }
      } catch (error) {
        console.error('Continue shopping product lookup failed:', error);
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
      } else {
        window.location.assign(root);
      }
      return;
    }

    const checkout = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (checkout && hasWidget()) {
      if (!state.verified) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setFeedback('Select delivery or pickup to continue.', 'error');
        openDialog();
        return;
      }
      setCheckoutStarted(true);
    }
  }, true);

  document.addEventListener('input', (event) => {
    if (
      event.target.matches('[data-rural-postcode]') &&
      hasWidget()
    ) {
      const widget = event.target.closest('[data-rural-surcharge-gatekeeper]');
      const postcode = cleanPostcode(event.target.value);
      setInputs(postcode);
      state.method = 'delivery';
      state.postcode = postcode;
      state.classification = null;
      setDialogMethod('delivery');
      setVerified(false);
      setContinueEnabled(false);
      setFeedback('');
      if (widget) state.activeWidget = widget;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.documentElement.classList.contains('srvp-rural-dialog-open')) {
      closeDialogs();
    }
  });

  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(refresh);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  window.SRVP_RURAL_SURCHARGE = { refresh, openDialog };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      state.restoreStarted = false;
      window.requestAnimationFrame(refresh);
    });
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted && checkoutRecheckRequired()) {
      setVerified(false);
      setFeedback('Confirm that this postcode matches your checkout delivery address.', 'error');
      openDialog();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
